import { Select, Table, TableColumnsType } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { getRegularOceans } from "../../../api/oceanManagement.api";
import useAxios from "../../../hooks/useAxios";
import useUtil from "../../../hooks/useUtil";
import config from "../../../lib/config";
import { IGetRegularOceans, IRegularOceanItem } from "../../../models/oceanManagement.model";
import Button from "../../Button";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Pagination from "../../Pagination";
import SelectCampus from "../../SelectCampus";

const Regular = () => {
  const { t , i18n } = useTranslation();
  const history = useHistory();
  const { isCampusDeactived } = useUtil();
  const { data: res, isLoading, error, execute } = useAxios<IGetRegularOceans>();

  const [data, setData] = useState<IRegularOceanItem[]>([]);
  const [eduStepCode, setEduStepCode] = useState('');
  const [pageNo, setPageNo] = useState(1);
  const [campusDeactived, setCampusDeactived] = useState(false);

  useEffect(() => {
    setCampusDeactived(isCampusDeactived());
    execute(getRegularOceans());
  }, []);

  useEffect(() => {
    if (res) {
      setData(res.data);
    }
  }, [res]);

  const onSetEduStepCode = (value: string) => {
    setEduStepCode(value);
    if (value) {
      const filtered = res?.data.filter(item => item.eduStepCode === value);
      setData(filtered || []);
    } else {
      setData(res?.data || []);
    }
  };

  const columns: TableColumnsType<IRegularOceanItem> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      align: 'center',
      render: (value, record) => i18n.language === 'ko' ? value : record.campusEngName,
    },
    {
      title: t('class.class.9'),
      dataIndex: 'eduStepCode',
      align: 'center',
      render: value => value === 'EM' ? 'OCEAN' : 'Prediger',
    },
    {
      title: t('class.ocean.column1'),
      dataIndex: 'name',
      align: 'center',
    },
    {
      title: t('class.ocean.column2'),
      dataIndex: 'srtDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD'),
    },
    {
      title: t('class.ocean.column3'),
      dataIndex: 'endDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD'),
    },
    {
      title: t('class.ocean.column4'),
      dataIndex: 'regCount',
      align: 'center',
    },
    {
      title: t('class.ocean.column5'),
      dataIndex: 'regDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD'),
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <div className="comm-bx__between">
        <div>
          <Select
            className="w-150p"
            value={eduStepCode} 
            onChange={value => onSetEduStepCode(value)}
          >
            <Select.Option value="">{t('common.text.all')}</Select.Option>
            <Select.Option value="EM">OCEAN</Select.Option>
            <Select.Option value="MD">Prediger</Select.Option>
          </Select>
        </div>
        <div className="comm-btn__area">
          <SelectCampus className="w-150p" />
          <Button
            className="btn-basic pink"
            onClick={() => history.push('/class/ocean/create')}
            disabled={campusDeactived}
            text={t('class.ocean.button1')}
          />          
        </div>
      </div>
      <div className='comm-table__area'>
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: pageNo,
            pageSize: config.pageSize,
          }}
          onRow={(record) => {
            return {
              onClick: () => {
                history.push(`/class/ocean/${record.scheduleCode}`);
              },
            };
          }}
          rowClassName="pointer"
        />
      </div>
      <div className="comm-bx__between">
        <div className="common-paging center">
          <Pagination
            count={data.length}
            page={pageNo}
            setPage={setPageNo}
          />
        </div>
      </div>
    </>
  );
}

export default Regular;
